document.querySelectorAll('.js--accordion-trigger').forEach(header => {
    header.addEventListener('click', () => {
        const item = header.closest('.js--accordion-item');
        if (!item) return;

        const content = item.querySelector('.js--accordion-content');
        if (!content) return;

        const isExpanded = header.getAttribute('aria-expanded') === 'true';

        // 状態の反転
        header.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
        item.classList.toggle('is-open');
    });
});


/* フォーマット例

<article class="faq-card__item js--accordion-item">
    <div class="faq-card__item-q">
        <p class="text">質問文</p>
        <button class="button js--accordion-trigger" aria-expanded="false" aria-controls="content-1" aria-label="開く"></button>
    </div>
    <div id="content-1" class="faq-card__item-a js--accordion-content" aria-hidden="true">
        <p class="text">回答文</p>
    </div>
</article>

*/